
import React from 'react';
import { EnhancedCrawlResult } from '@/types/crawler';
import OverviewContainer from '@/components/dashboard/overview/OverviewContainer';
import OverviewHeader from '@/components/dashboard/overview/OverviewHeader';

interface DashboardOverviewProps {
  crawlResult: EnhancedCrawlResult;
  onNewCrawl: () => void;
  onNavigate: (page: string) => void;
  onSelectPage?: (url: string) => void;
}

const DashboardOverview: React.FC<DashboardOverviewProps> = ({
  crawlResult,
  onNewCrawl,
  onNavigate,
  onSelectPage
}) => {
  // Add debug logging to see what's in the crawl result
  console.log('DashboardOverview rendering with crawl result:', {
    url: crawlResult.url,
    pagesCount: crawlResult.pages.length
  });
  
  return (
    <div className="grid gap-6" data-testid="dashboard-overview-container">
      <OverviewHeader 
        crawlResult={crawlResult}
        onNewCrawl={onNewCrawl}
      />
      <OverviewContainer 
        crawlResult={crawlResult} 
        onSelectPage={onSelectPage} 
      />
      {/* Ensuring no additional components are rendered here that might show "Top Performing Pages" */}
    </div>
  );
};

export default DashboardOverview;
